import { AnalyticsSelectedProductType } from "@intelligems/ig-types";
import { fromGqlId } from "@src/api/formatters/shopify";

/**
 * Merge fetched product data into the selected-products filter.
 *
 * Products that already have a `handle` are returned untouched. Products still
 * missing a `handle` get their resolved `title`/`handle` filled in when data is
 * available. When `dropUnresolved` is true (the fetch has completed and the id
 * still didn't resolve — e.g. a deleted/restricted product in a stale shared
 * link), the product is removed entirely. Dropping is required because the
 * `hasUnresolvedProducts` gate in get-tinybird-experience-analysis blocks the
 * whole dashboard while any selected product lacks a handle.
 */
export const mergeHydratedAnalyticsProducts = (
  products: AnalyticsSelectedProductType[],
  productDataById: Record<string, { title: string; handle: string }>,
  dropUnresolved: boolean
): AnalyticsSelectedProductType[] =>
  products
    .map((product) => {
      if (product.handle) {
        return product;
      }
      const data = productDataById[fromGqlId(product.id)];
      if (data) {
        return { ...product, title: data.title, handle: data.handle };
      }
      return dropUnresolved ? null : product;
    })
    .filter(
      (product): product is AnalyticsSelectedProductType => product !== null
    );
